import { render } from "./remote_user_resolver.vue?vue&type=template&id=147deeb8"
import script from "./remote_user_resolver.js?vue&type=script&lang=js"
export * from "./remote_user_resolver.js?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__